import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PanelSection from 'components/v2/PanelSection';
export default function ListItemSummary({ children, className }) {
    return (React.createElement(PanelSection, { className: classNames(className) }, children));
}
ListItemSummary.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.arrayOf([PropTypes.string, PropTypes.object]),
    ]),
};
